import React, { useContext, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CreateVenueForm from '../components/CreateVenueForm';
import SearchVenues from '../utils/SearchVenues';
import { UserContext } from '../context/userContext';
import { getAllVenues, getVenueById } from '../services/venue-services';
import { refreshAuthToken } from '../services/auth-services';

function CreateVenue() {
  const { currentUserState } = useContext(UserContext);
  const [displayEditForm, setDisplayEditForm] = useState()
  const [venueData, setVenueData] = useState()
  const [venueSearchKey] = useState(0)
  const [venues, setVenues] = useState([])
  const [refreshToken, setRefreshToken] = useState()

  useEffect(() => {
    const loadVenues = async () => {
      refreshAuthToken().then(token => {
        setRefreshToken(token)
        loadVenueData(token)
      })

    }
    loadVenues();
  }, [])

  const loadVenueData = (token) => {
    getAllVenues(token).then(response => {
      var responseJson = response.data;
      var mainArray = []
      for (var i = 0; i < responseJson.length; i++) {
        var venueName = responseJson[i].venueName;
        var venueId = responseJson[i].venueId;
        var venuePostcode = responseJson[i].venuePostcode
        var object = { "label": venueName + " " + venuePostcode, "value": venueId }
        mainArray.push(object)
      }
      setVenues(mainArray)
  })
  }
  const handleVenueChange = (newValue) => {
    if(newValue !== null){
      console.log(newValue.value)
      getVenueById(newValue.value, refreshToken).then(response => {
        setVenueData(response.data)
        setDisplayEditForm(true)
      })
    }
    else{
      setDisplayEditForm(false)
      setVenueData()
    }
  }

  const refreshVenues = () => {
    setDisplayEditForm(false)
    setVenueData()
    loadVenueData(refreshToken)
  }

  const displayTheEditForm = () => {
    if(displayEditForm){
      return(
        <div key={venueData[0].venueName}>
        <CreateVenueForm  editMode={true} venueData={venueData} refreshVenues={() => refreshVenues()} refreshToken={refreshToken}/>
        </div>
      )
    }
  }

  return (
    <Container style={{height:"100vh", backgroundColor:"#091440", backgroundPosition:"top", color:"white"}} fluid>
    <Row>
      <Col>
        <h1>Create Venue</h1>
        <CreateVenueForm editMode={false} refreshVenues={() => refreshVenues()} refreshToken={refreshToken}/>
      </Col>

    </Row>
    <Row style={{marginTop:10, backgroundColor: "#091440", marginBottom:10}}>
        <Col>
        <h1>Edit Venue</h1>
        <React.Fragment key={venueSearchKey}>
        <Container style={{ backgroundColor: "white", paddingTop: 50, paddingBottom: 50, borderRadius: 10 }} key={venueSearchKey}>
          <SearchVenues handleVenueChange={(newValue) => handleVenueChange(newValue)} venueData={venues} userRole={currentUserState} keyChange={venueSearchKey} />
          {displayTheEditForm()}
        </Container>
        </React.Fragment>
        </Col>
        
    </Row>
  </Container>
  );
}

export default CreateVenue